import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Store references to hidden dialogs
    this.hiddenDialogs = [];
  }

  hideVisibleDialogs() {
    // Find and hide ONLY visible Stimulus dialogs
    this.hiddenDialogs = [];

    // Target only visible dialogs by checking aria-hidden attribute
    const visibleDialogs = document.querySelectorAll('#main-dialog');

    if (visibleDialogs.length > 0) {
      visibleDialogs.forEach(dialog => {
        // Store reference to the dialog to restore it later
        this.hiddenDialogs.push(dialog);
        dialog.close()
      });
      console.log(`Hidden ${this.hiddenDialogs.length} visible dialogs`);
    }
  }

  restoreHiddenDialogs() {
    // Only restore dialogs if we have any hidden
    if (this.hiddenDialogs.length > 0) {
      this.hiddenDialogs.forEach(dialog => {
        dialog.show
      });
      console.log(`Restored ${this.hiddenDialogs.length} hidden dialogs`);
      this.hiddenDialogs = [];
    }
  }

  setupModalEvents(modalEl) {
    // Set up event listeners for the modal to restore dialogs when closed
    modalEl.addEventListener('hidden.bs.modal', () => {
      this.restoreHiddenDialogs();
    });
  }

  show(event) {
    event.preventDefault();
    const href = this.element.getAttribute('href')
    const modalEl = document.getElementById('deleteConfirmationModal');

    if (modalEl && href) {
      const buttonEl = modalEl.querySelector('form.button_to');
      const confirmTextEl = modalEl.querySelector('.confirm-text');
      const confirmTitleEl = modalEl.querySelector('.confirm-title');

      buttonEl.setAttribute('action', href);
      confirmTextEl.innerHTML = this.element.dataset.confirmText;
      confirmTitleEl.innerHTML = this.element.dataset.confirmTitle;

      // Hide only visible Stimulus dialogs before showing the modal
      // this.hideVisibleDialogs();

      // Set up event listeners for the modal
      // this.setupModalEvents(modalEl);

      const modal = new bootstrap.Modal(modalEl, {});
      modal.show();
    }
  }

  help(event) {
    event.preventDefault();
    const modalEl = document.getElementById('helpModal');
    if (modalEl) {
      const modalTitle = modalEl.querySelector('.modal-title');
      const modalHelp = modalEl.querySelector('.help-text');
      modalTitle.innerHTML = event.target.dataset.helpTitle;
      modalHelp.innerHTML = event.target.dataset.helpMessage;

      // Hide only visible Stimulus dialogs before showing the modal
      this.hideVisibleDialogs();

      // Set up event listeners for the modal
      this.setupModalEvents(modalEl);

      const modal = new bootstrap.Modal(modalEl, {});
      modal.show();
    }
  }
}